// Submitted build60 ExploreLandingScreen: this is a five-panel feature row,
// not the repeating SponsoredAlbumRail policy used by the release shelves.
export function exploreRecommendations(items = [], campaigns = [], unknownArtist = '') {
  const advertised = new Set(campaigns.flatMap((c) => c.albums.map((a) => a.id)));
  const entries = items
    .filter((item) => !advertised.has(item.albumId))
    .slice(0, 5)
    .map((item) => ({ item }));
  campaigns
    .filter((c) => c.placements[0]?.format === 'NATIVE_ALBUM' && c.albums.length)
    .forEach((campaign) => {
      const album = campaign.albums[0];
      const item = {
        albumId: album.id,
        albumSlug: album.slug,
        albumTitle: album.title,
        albumImageUrl: campaign.imageUrl || album.imageUrl,
        artist: album.artist ?? { name: unknownArtist },
        albumContentRating: album.contentRating,
        recommendationComment: campaign.subheadline,
        isAdMarked: true,
      };
      const index = Math.min(
        campaign.placements[0]?.startAfterOrganic ?? entries.length,
        entries.length,
      );
      entries.splice(index, 0, { item, campaign });
    });
  return entries.slice(0, 5);
}
